import { render, staticRenderFns } from "./manageDisabilitycard.vue?vue&type=template&id=38c9a1de&scoped=true&"
import script from "./manageDisabilitycard.vue?vue&type=script&lang=js&"
export * from "./manageDisabilitycard.vue?vue&type=script&lang=js&"
import style0 from "./manageDisabilitycard.vue?vue&type=style&index=0&id=38c9a1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9a1de",
  null
  
)

export default component.exports